module.exports = __webpack_public_path__ + "static/media/graphic-academy-med.4cb13b2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/graphic-academy-med.svg
// module id = 192
// module chunks = 0